export default {"src":"/_next/static/media/kids.f57ee828.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};